import * as React from "react";
import {
  TaskListTitleWrapper,
  TaskTitleLabel,
  TaskCloseListIcon,
} from "src/components/TaskListPanel/TaskListTitle/TaskListTitle.components";

export interface Props {
  closeTaskList: () => void;
}

export const TaskListTitle: React.FunctionComponent<Props> = ({
  closeTaskList,
}) => {
  return (
    <TaskListTitleWrapper>
      <TaskTitleLabel>List of tasks</TaskTitleLabel>
      <TaskCloseListIcon
        data-testid="taskListCloseIcon"
        onClick={() => {
          closeTaskList();
        }}
      />
    </TaskListTitleWrapper>
  );
};

export default TaskListTitle;
